import * as React from 'react'
import { LegacyAntdModal } from 'components/LegacyAntdModal/LegacyAntdModal'

import Styles from './InfoModal.module.scss'
import { Button } from 'blaze-ui/Button'

// InfoModal confirmations open over already-stacked modals (e.g. the Settings panel,
// which renders on the almanac-ui ModalStack at z-index 1000 / close buttons at 1001),
// so it must sit above the stack to stay visible and clickable.
const ABOVE_MODAL_STACK_Z_INDEX = 1002

interface Props {
  visible: boolean
  children?: React.ReactNode
  setVisible: (visible: boolean) => void
  title: string
  onCancel?: () => void
  onOk?: () => boolean
  okText?: string
  cancelText?: string
  hideCancel?: boolean
  actionsDisabled?: boolean
}

const InfoModal = ({
  visible,
  setVisible,
  title,
  onCancel,
  onOk,
  children,
  okText,
  cancelText,
  hideCancel,
  actionsDisabled,
}: Props) => {
  const onHide = () => {
    setVisible(false)
    if (onCancel) onCancel()
  }

  const onConfirm = () => {
    if (onOk) {
      setVisible(!onOk())
    } else {
      setVisible(false)
    }
  }

  return (
    <LegacyAntdModal visible={visible} onCancel={onHide} closable={false} zIndex={ABOVE_MODAL_STACK_Z_INDEX}>
      <div>
        <div className={Styles.title}>{title}</div>
        <div className={Styles.content}>{children}</div>
        <div className={Styles.footer}>
          {!hideCancel && (
            <Button size="md" onPress={onHide} variant="secondary" data-testid="cancel" isDisabled={actionsDisabled}>
              {cancelText ? cancelText : 'Cancel'}
            </Button>
          )}
          <Button onPress={onConfirm} size="md" data-testid="confirm" isDisabled={actionsDisabled}>
            {okText ? okText : 'Ok'}
          </Button>
        </div>
      </div>
    </LegacyAntdModal>
  )
}

export default InfoModal
